<template>
  <div class="pe-root">
    <div class="pe-page">
      <div class="container-index-trip">
      <div class="header-inspi mb-5">
        <div id="banner-made-trip">
          <div class="pe-banner-title-wrap text-center px-3">
            <h1 class="pe-banner-title-p" :class="isPhone ? 'merriweather-reg-26 px-3' : 'merriweather-reg-32'">Des maisons de vacances d’exception pour un séjour inoubliable</h1>
            <p class="pe-banner-subtitle-p merriweather-reg-18 mb-0">Villas • Maisons • Chalets • Domaines de charme</p>
          </div>
          <div class="btn-banner" @click="scrollToContact">
            <div class="hortense-btn-primary raleway-semi-p13 text-uppercase">
              Trouver mon lieu idéal
            </div>
          </div>
          <div class="btn-banner-phone" @click="scrollToContact">
            <div class="hortense-btn-primary raleway-semi-p13 text-uppercase">
              Trouver mon lieu idéal
            </div>
          </div>
          <div class="image-overlay"></div>
        </div>
        
        <!-- Horizontal Search Bar - Only show on desktop -->
        <LodgingSearchBar v-if="!isPhone && false" redirectTo="/collections/evenement-eco-responsable" class="banner-lodge-search" />
    </div>

       <!-- Custom Event Section -->
       <div class="custom-event-section py-5">
         <div class="container">
           <div class="row align-items-start" style="margin-left: -55px; margin-right: -55px;">
             <div :class="[
               isPhone ? 'col-12 order-1' : 'col-6 order-2'
             ]">
               <div :class="{ 'px-5': isPhone, 'ps-4': !isPhone }">
                 <div class="top-container text-center w-100">
                   <h4 class="mb-0">Vos vacances</h4>
                   <h1 class="mb-4">sur mesure</h1>
                 </div>

                 <p class="custom-event-text raleway-reg-p15 mb-4">
                   Envie de vous retrouver en famille ou entre amis, de ralentir le rythme ou de vivre une parenthèse hors du temps… chaque séjour mérite un lieu qui lui ressemble.</br>Hortense sélectionne des domaines, châteaux, villas et chalets de caractère, pensés pour accueillir vos plus beaux moments d'évasion.</br>Journées au bord de la piscine, découvertes locales, instants de détente ou activités sur mesure : chaque séjour se façonne selon vos envies.</br>Plus qu’un lieu, offrez-vous une expérience où chaque détail compte, où les instants se savourent pleinement et se transforment en souvenirs durables.
                 </p>

                 <div class="hortense-btn-primary" @click="scrollToContact">
                   FAIRE UNE DEMANDE
                 </div>
               </div>
             </div>

             <!-- Video Column (should come SECOND on phone) -->
             <div :class="[
               isPhone ? 'col-12 order-2 mb-4' : 'col-6 order-1'
             ]">
               <video
                 src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/location-maison-vacances-vid.mov"
                 autoplay
                 loop
                 muted
                 playsinline
                 webkit-playsinline
                 disablepictureinpicture
                 controlslist="nodownload nofullscreen noremoteplayback"
                 class="custom-event-video"
                 :class="isPhone ? 'mt-3' : ''"
               ></video>
             </div>
           </div>
         </div>
       </div>

       <div id="my-form-container" class="pe-contact">
         <h2 class="pe-contact__title" :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'">
           Nous contacter
         </h2>
         <p class="pe-contact__text raleway-reg-p15">
           Séjour en famille ou escapade entre amis… partagez votre projet, Hortense vous accompagne pour trouver le lieu idéal, à la hauteur de vos envies. Vous pouvez également nous joindre par téléphone au
           <a href="https://wa.me/33626203846" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; color: #3B6152">
             06 26 20 38 46
           </a>.
         </p>

         <div class="pe-contact__form-wrap">
           <hr class="pe-contact__form-divider" />

           <div id="my-form" class="pe-contact__form">

             <!-- NOM + PRÉNOM -->
             <div class="pe-form-row">
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15" for="pe_last_name">NOM</label>
                 <input
                   id="pe_last_name"
                   v-model="contactForm.last_name"
                   type="text"
                   name="NOM"
                   class="pe-form-input"
                 />
                 <span v-if="formErrors.last_name" class="pe-form-error">{{ formErrors.last_name }}</span>
               </div>
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15" for="pe_first_name">PRÉNOM</label>
                 <input
                   id="pe_first_name"
                   v-model="contactForm.first_name"
                   type="text"
                   name="PRENOM"
                   class="pe-form-input"
                 />
                 <span v-if="formErrors.first_name" class="pe-form-error">{{ formErrors.first_name }}</span>
               </div>
             </div>

             <!-- EMAIL + TÉLÉPHONE -->
             <div class="pe-form-row">
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15" for="pe_email">EMAIL</label>
                 <input
                   id="pe_email"
                   v-model="contactForm.email"
                   type="email"
                   name="EMAIL"
                   class="pe-form-input"
                 />
                 <span v-if="formErrors.email" class="pe-form-error">{{ formErrors.email }}</span>
               </div>
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15" for="pe_phone">TÉLÉPHONE</label>
                 <input
                   id="pe_phone"
                   v-model="contactForm.phone"
                   type="text"
                   name="TELEPHONE"
                   class="pe-form-input"
                 />
                 <span v-if="formErrors.phone" class="pe-form-error">{{ formErrors.phone }}</span>
               </div>
             </div>

             <!-- DESTINATION -->
             <div class="pe-form-row pe-form-row--full">
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15" for="pe_destination">DESTINATION SOUHAITÉE</label>
                 <input
                   id="pe_destination"
                   v-model="contactForm.destination"
                   type="text"
                   name="DESTINATION"
                   class="pe-form-input"
                 />
                 <span v-if="formErrors.destination" class="pe-form-error">{{ formErrors.destination }}</span>
               </div>
             </div>

             <!-- NOMBRE D'ADULTES + NOMBRE D'ENFANTS -->
             <div class="pe-form-row">
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15" for="pe_adults">NOMBRE D'ADULTES</label>
                 <input
                   id="pe_adults"
                   v-model="contactForm.nombre_adultes"
                   type="number"
                   min="0"
                   class="pe-form-input"
                 />
                 <span v-if="formErrors.nombre_adultes" class="pe-form-error">{{ formErrors.nombre_adultes }}</span>
               </div>
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15" for="pe_children">NOMBRE D'ENFANTS</label>
                 <input
                   id="pe_children"
                   v-model="contactForm.nombre_enfants"
                   type="number"
                   min="0"
                   class="pe-form-input"
                 />
                 <span v-if="formErrors.nombre_enfants" class="pe-form-error">{{ formErrors.nombre_enfants }}</span>
               </div>
             </div>

             <!-- DATES DE L'ÉVÉNEMENT -->
             <div class="pe-form-row pe-form-row--full">
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15 text-uppercase">date du séjour</label>
                 <input style="display:none" type="text" ref="startDateInput" name="DEPART" class="form-control raleway-reg-p13" placeholder="Date de départ" id="depart">
                 <input style="display:none" type="text" ref="endDateInput" name="RETOUR" class="form-control raleway-reg-p13" placeholder="Date de retour" id="retour">
                 <div class="made-trip-duration">
                   <CommonDatePicker
                       :startDate="minDate"
                       :endDate="maxDate"
                       ref="datePicker"
                       @periodSelected="selectDates"
                   />
                 </div>
                 <span v-if="formErrors.dates_sejour" class="pe-form-error">{{ formErrors.dates_sejour }}</span>
               </div>
             </div>

             <!-- FLEXIBILITÉ SUR LES DATES -->
             <div class="pe-form-row pe-form-row--full">
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15 text-uppercase" for="pe_flexible">ÊTES-VOUS FLEXIBLE SUR LES DATES ?</label>
                 <v-select
                   id="pe_flexible"
                   v-model="flexibleSelected"
                   :options="flexibleChoices"
                   name="FLEXIBLE"
                   class="pe-form-select"
                 />
                 <span v-if="formErrors.flexibleSelected" class="pe-form-error">{{ formErrors.flexibleSelected }}</span>
               </div>
             </div>

             <!-- TYPE D'ÉTABLISSEMENT -->
             <div class="pe-form-row pe-form-row--full">
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15" for="pe_lodge_type">QUEL TYPE D'ÉTABLISSEMENT PRIVILÉGIEZ-VOUS ?</label>
                 <multiselect
                   id="pe_lodge_type"
                   name="ETABLISSEMENT"
                   :options="lodgeTypeChoices"
                   :multiple="true"
                   placeholder="Sélectionnez..."
                   v-model="lodgeTypeSelected"
                   class="pe-form-multiselect"
                 />
                 <span v-if="formErrors.lodgeTypeSelected" class="pe-form-error">{{ formErrors.lodgeTypeSelected }}</span>
               </div>
             </div>

             <!-- DE QUOI AVEZ-VOUS BESOIN ? -->
             <div class="pe-form-row pe-form-row--full">
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15" for="pe_needs">DE QUOI AVEZ-VOUS BESOIN ?</label>
                 <multiselect
                   id="pe_needs"
                   name="BESOIN"
                   :options="needChoices"
                   :multiple="true"
                   placeholder="Sélectionnez..."
                   v-model="needSelected"
                   class="pe-form-multiselect"
                 />
                 <span v-if="formErrors.needSelected" class="pe-form-error">{{ formErrors.needSelected }}</span>
               </div>
             </div>

             <!-- BUDGET TOTAL -->
             <div class="pe-form-row pe-form-row--full">
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15 mb-0 text-uppercase" for="pe_budget">budget total du séjour</label>
                 <p class="raleway-it-l13 mb-2">Seules les demandes de séjour dont le montant total est supérieur à <span class="raleway-bold-p13">3 000 €</span> seront traitées par nos équipes.</p>
                 <textarea
                   id="pe_budget"
                   v-model="contactForm.budget"
                   name="BUDGET"
                   class="pe-form-input"
                   placeholder="À partir de 3000€"
                 ></textarea>
                 <span v-if="formErrors.budget" class="pe-form-error">{{ formErrors.budget }}</span>
               </div>
             </div>

             <!-- MESSAGE COMPLÉMENTAIRE -->
             <div class="pe-form-row pe-form-row--full">
               <div class="pe-form-group">
                 <label class="pe-form-label raleway-semi-p15" for="pe_message">MESSAGE COMPLÉMENTAIRE</label>
                 <textarea
                   id="pe_message"
                   v-model="contactForm.message"
                   name="PROJET"
                   class="pe-form-input pe-form-textarea"
                   rows="5"
                   placeholder="Décrivez votre projet..."
                 ></textarea>
                 <span v-if="formErrors.message" class="pe-form-error">{{ formErrors.message }}</span>
               </div>
             </div>

             <!-- Error / Success messages -->
             <div v-if="contactErrorMessage" class="pe-form-feedback pe-form-feedback--error raleway-reg-p13">
               {{ contactErrorMessage }}
             </div>
             <div v-if="contactSuccessMessage" class="pe-form-feedback pe-form-feedback--success raleway-reg-p13">
               {{ contactSuccessMessage }}
             </div>

             <!-- Submit -->
             <div class="pe-form-actions">
               <button
                 type="button"
                 class="hortense-btn-primary pe-form-submit"
                 :disabled="contactSubmitting"
                 @click="submit"
               >
                 {{ contactSubmitting ? 'ENVOI EN COURS...' : 'ENVOYER MA DEMANDE' }}
               </button>
               <p id="my-form-status"></p>
             </div>

           </div>
         </div>
       </div>

       <AccommodationCard
         v-if="!isPhone"
         :user="this.user"
         :lodgings="accommodations"
         :buttonText="'Découvrir toutes les nouveautés'"
         :onlyCurrentCollection="true"
         class="mb-2 pb-2"
         @collectionSelected="selectedCollection = $event"
       />
       <AccommodationPhoneCard v-else :user='user' :onlyCurrentCollection="true" :lodgings="accommodations" :buttonText="'Découvrir toutes les nouveautés'" @collectionSelected="selectedCollection = $event"></AccommodationPhoneCard>
       <section class="icon-difference py-5 mt-5 text-center" style="background-color: #f2f7f3;" data-aos="fade-up" data-aos-duration="900">
         <h4 class="mb-2" :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'">Faites le choix d'un séjour</h4>
         <h1 class=" mb-5" :class="isPhone ? 'merriweather-reg-26' : 'merriweather-reg-40'">qui fait la différence</h1>
         <div class="icon-wrapper" data-aos="fade-up" data-aos-duration="900">
           <div class="icon-grid">
             <div class="icon-card zoom-img-containerr" v-for="(icon, index) in icons" :key="index"  :style="{ marginTop: index === 0 || index === 3  ? '1.5vh' : '' }">
               <img :src="icon.image" :alt="icon.alt" />
               <p class="raleway-bold-16 text-uppercase" v-html="icon.label"></p>
           </div>
           </div>
         </div>
       </section>
     </div>
     </div>

     <!-- Success Modal -->
     <ModalPrivateEventSuccess
       v-if="showSuccessModal"
       @close="showSuccessModal = false"
       :holidayRental="true"
     />

     <!-- ══════════════════════════════════════════════════════════════
          BOTTOM STICKY BAR — fixed at bottom, always on top
     ══════════════════════════════════════════════════════════════ -->
     <div class="pe-sticky-bar">
       <p class="pe-sticky-bar__text text-uppercase" :class="isPhone ? 'merriweather-reg-13 text-center' : 'merriweather-reg-18'">
         TROUVEZ LE LIEU IDÉAL PARMI NOS VILLAS, MAISONS ET DOMAINES.
       </p>
       <button
         @click="scrollToContact"
         class="pe-sticky-bar__btn" :class="isPhone ? 'raleway-semi-p13' : 'raleway-semi-p18'"
       >
         NOUS CONTACTER
       </button>
     </div>
   </div>
</template>


<script>
import Multiselect from 'vue-multiselect';
import {VueDatePicker} from "@mathieustan/vue-datepicker";
import LodgingSearchBar from '../shared/LodgingSearchBar.vue';
import AccommodationCard from '../cards/AccommodationCard.vue';
import AccommodationPhoneCard from '../cards/AccommodationPhoneCard.vue';
import ModalPrivateEventSuccess from '../modals/ModalPrivateEventSuccess.vue';
import SeminarDifference from 'components/SeminarDifference.vue';
import fetcher from "packs/shared/api.js";

export default {
  name: 'HolidayHomeRental',
  props: ["user"],
  components: {VueDatePicker, Multiselect, LodgingSearchBar, AccommodationCard, AccommodationPhoneCard, ModalPrivateEventSuccess, SeminarDifference},

  data() {
    return {
      showSuccessModal: false,
      currentDate: new Date(),
      selectedDate: null,
      selectedStartDate: null,
      selectedEndDate: null,
      datepickerFormat: 'DD/MM/YYYY',
      datepickerLanguage: 'fr',
      lodgeTypeChoices: [
        "Hôtels",
        "Chambres d'hôtes",
        "Gites & Maisons",
        "Villas",
        "Chalets",
        "Lieux insolites",
        "Autre"
      ],
      needChoices: [
        "Hébergement seul",
        "Hébergement + petit déjeuner",
        "Hébergement + demi-pension",
        "Hébergement + pension complète",
        "Chef à domicile",
        "Traiteur",
        "Service de baby-sitting / nounous",
        "Autres (à préciser en message complémentaire)"
      ],
      flexibleChoices: [
        "Oui",
        "Non"
      ],
      flexibleSelected: null,
      minDate: new Date().toISOString().substr(0, 10),
      needSelected: [],
      lodgeTypeSelected: [],
      accommodations: [],
      selectedCollection: null,
      contactErrorMessage: '',
      contactSuccessMessage: '',
      contactSubmitting: false,
      formErrors: {},
      contactForm: {
        last_name: '',
        first_name: '',
        email: '',
        phone: '',
        country: '',
        postal: '',
        destination: '',
        event_type: '',
        nombre_adultes: '',
        nombre_enfants: '',
        dates_sejour: '',
        budget: '',
        message: '',
        lodge_type: [],
        needs: []
      },
      icons: [
        {
          image: require('../../images/Groupe 151.svg'),
            alt: "Maison",
            label: "UNE SÉLECTION UNIQUE DE LIEUX DE CHARME"
        },
        {
            image: require('../../images/Groupe 1622.svg'),
            alt: "Checklist",
            label: "UNE ORGANISATION CLÉ EN MAIN"
        },
        {
            image: require('../../images/Groupe 175.svg'),
            alt: "Bien-être",
            label: "DES HÉBERGEMENTS RESPECTUEUX DE L'ENVIRONNEMENT"
        },
        {
            image: require('../../images/Groupe 158.svg'),
            alt: "Cadeau",
            label: "Un moment privilégié à offrir à vos proches"
        }
      ]
    }
  },
  watch: {
    selectedCollection() {
      this.fetchHomeLoadings();
    }
  },
  mounted() {
    let svgElements = document.querySelectorAll('.vs__open-indicator');
    svgElements.forEach(function (svgElement) {
      let pathElement = svgElement.querySelector('path');
      pathElement.setAttribute('d', 'M11.178 19.569a.998.998 0 0 0 1.644 0l9-13A.999.999 0 0 0 21 5H3a1.002 1.002 0 0 0-.822 1.569l9 13z');
      pathElement.setAttribute('fill', '#3B6152');
      svgElement.setAttribute('viewBox', '5 5 15 15');
    });
    this.fetchHomeLoadings();
    const whatsappBtn = document.getElementById('whatsapp-button');
	  if (whatsappBtn) whatsappBtn.style.top = '80%';
  },
  beforeDestroy() {
  },
  computed: {
    minDate() {
      return new Date(
          this.currentDate.getFullYear(),
          this.currentDate.getMonth(),
          this.currentDate.getDate()
      );
    },
    maxDate() {
      return new Date(
          this.currentDate.getFullYear() + 1,
          this.currentDate.getMonth(),
          this.currentDate.getDate()
      );
    },
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    scrollToContact() {
      const contactSection = document.getElementById('my-form-container');
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    formatDate(date) {
      if (!date) return null;
      const set = new Date(date);
      const options = {year: "numeric", month: "numeric", day: "numeric"};
      return set.toLocaleString("fr", options);
    },
    selectDates(event, start, end) {
      this.selectedStartDate = start ? new Date(start) : null;
      this.selectedEndDate = end ? new Date(end) : null;
      const formattedStart = this.formatDate(start);
      const formattedEnd = this.formatDate(end);
      document.getElementById('depart').value = formattedStart;
      document.getElementById('retour').value = formattedEnd;
      this.contactForm.dates_sejour = `${formattedStart} – ${formattedEnd}`;
    },
    validateForm() {
      this.formErrors = {};
      let isValid = true;
      // Validate NOM
      if (!this.contactForm.last_name || this.contactForm.last_name.trim() === '') {
        this.formErrors.last_name = 'Le nom est requis.';
        isValid = false;
      }

      // Validate PRÉNOM
      if (!this.contactForm.first_name || this.contactForm.first_name.trim() === '') {
        this.formErrors.first_name = 'Le prénom est requis.';
        isValid = false;
      }

      // Validate EMAIL
      if (!this.contactForm.email || this.contactForm.email.trim() === '') {
        this.formErrors.email = 'L\'email est requis.';
        isValid = false;
      } else if (!this.isValidContactEmail(this.contactForm.email)) {
        this.formErrors.email = 'Veuillez saisir une adresse e-mail valide.';
        isValid = false;
      }

      // Validate TÉLÉPHONE
      if (!this.contactForm.phone || this.contactForm.phone.trim() === '') {
        this.formErrors.phone = 'Le téléphone est requis.';
        isValid = false;
      }

      // Validate DESTINATION
      if (!this.contactForm.destination || this.contactForm.destination.trim() === '') {
        this.formErrors.destination = 'La destination est requise.';
        isValid = false;
      }

      // Validate NOMBRE D'ADULTES
      if (!this.contactForm.nombre_adultes || this.contactForm.nombre_adultes === '') {
        this.formErrors.nombre_adultes = 'Le nombre d\'adultes est requis.';
        isValid = false;
      }

      // Validate NOMBRE D'ENFANTS
      if (!this.contactForm.nombre_enfants || this.contactForm.nombre_enfants === '') {
        this.formErrors.nombre_enfants = 'Le nombre d\'enfants est requis.';
        isValid = false;
      }

      // Validate DATES
      if (!this.contactForm.dates_sejour || this.contactForm.dates_sejour.trim() === '') {
        this.formErrors.dates_sejour = 'Les dates de l\'événement sont requises.';
        isValid = false;
      }

      // Validate FLEXIBILITÉ
      if (!this.flexibleSelected) {
        this.formErrors.flexibleSelected = 'Veuillez indiquer votre flexibilité sur les dates.';
        isValid = false;
      }

      // Validate TYPE D'ÉTABLISSEMENT
      if (!this.lodgeTypeSelected || this.lodgeTypeSelected.length === 0) {
        this.formErrors.lodgeTypeSelected = 'Veuillez sélectionner au moins un type d\'établissement.';
        isValid = false;
      }

      // Validate BESOINS
      if (!this.needSelected || this.needSelected.length === 0) {
        this.formErrors.needSelected = 'Veuillez sélectionner au moins un besoin.';
        isValid = false;
      }

      // Validate BUDGET
      if (!this.contactForm.budget || this.contactForm.budget.trim() === '') {
        this.formErrors.budget = 'Le budget est requis.';
        isValid = false;
      }

      // Validate MESSAGE
      if (!this.contactForm.message || this.contactForm.message.trim() === '') {
        this.formErrors.message = 'Le message est requis.';
        isValid = false;
      }

      return isValid;
    },

    async handleContactSubmit() {
       this.contactErrorMessage = '';
       this.contactSuccessMessage = '';

       // Validate all fields
       if (!this.validateForm()) {
         this.contactErrorMessage = 'Veuillez remplir tous les champs obligatoires.';
         return;
       }

       this.contactSubmitting = true;

       try {
         const formspreeData = {
           last_name: this.contactForm.last_name,
           first_name: this.contactForm.first_name,
           email: this.contactForm.email,
           phone: this.contactForm.phone,
           destination: this.contactForm.destination,
           nombre_adultes: this.contactForm.nombre_adultes,
           nombre_enfants: this.contactForm.nombre_enfants,
           dates_sejour: this.contactForm.dates_sejour,
           flexible: this.flexibleSelected,
           lodge_type: this.lodgeTypeSelected,
           needs: this.needSelected,
           budget: this.contactForm.budget,
           message: this.contactForm.message
         };

         const FORMSPREE_ID = 'xzdylogo';
         const response = await fetch(`https://formspree.io/f/${FORMSPREE_ID}`, {
           method: 'POST',
           headers: { 'Content-Type': 'application/json' },
           body: JSON.stringify(formspreeData)
         });

         if (response.ok) {
           // Track form submission in data layer (skip on localhost)
           if (!window.location.hostname.includes('localhost')) {
             const nombreAdultes = this.parseNumericValue(this.contactForm.nombre_adultes);
             const nombreEnfants = this.parseNumericValue(this.contactForm.nombre_enfants);
             const budgetNumber = this.parseNumericValue(this.contactForm.budget);
             const numberOfNights = this.calculateNumberOfNights(this.selectedStartDate, this.selectedEndDate);

             window.dataLayer = window.dataLayer || [];
             window.dataLayer.push({
               event: 'demand_villa_location',
               ecommerce: {
                 last_name: this.contactForm.last_name,
                 first_name: this.contactForm.first_name,
                 email: this.contactForm.email,
                 phone: this.contactForm.phone,
                 destination: this.contactForm.destination,
                 nombre_adultes: this.contactForm.nombre_adultes,
                 nombre_enfants: this.contactForm.nombre_enfants,
                 total_people: nombreAdultes + nombreEnfants,
                 dates_sejour: this.contactForm.dates_sejour,
                 number_of_nights: numberOfNights,
                 flexible: this.flexibleSelected,
                 lodge_type: this.lodgeTypeSelected,
                 needs: this.needSelected,
                 budget: this.contactForm.budget,
                 budget_number: budgetNumber,
                 message: this.contactForm.message
               }
             });
           }

           this.resetContactForm();
           this.showSuccessModal = true;
         } else {
           this.contactErrorMessage = "Une erreur est survenue lors de l'envoi. Veuillez réessayer.";
         }
       } catch (error) {
         console.error('Error submitting contact form:', error);
         this.contactErrorMessage = "Une erreur est survenue lors de l'envoi. Veuillez réessayer.";
       } finally {
         this.contactSubmitting = false;
       }
     },

    parseNumericValue(value) {
      if (value === null || value === undefined) return 0;
      const normalized = String(value).replace(/\s/g, '').replace(',', '.');
      const match = normalized.match(/\d+(\.\d+)?/);
      return match ? Number(match[0]) : 0;
    },

    calculateNumberOfNights(startDate, endDate) {
      if (!startDate || !endDate) return 0;
      const start = new Date(startDate);
      const end = new Date(endDate);
      const millisecondsPerNight = 1000 * 60 * 60 * 24;
      const diff = Math.round((end - start) / millisecondsPerNight);
      return diff > 0 ? diff : 0;
    },

    isValidContactEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    resetContactForm() {
      this.contactForm = {
        last_name: '',
        first_name: '',
        email: '',
        phone: '',
        country: '',
        postal: '',
        destination: '',
        event_type: '',
        nombre_adultes: '',
        nombre_enfants: '',
        dates_sejour: '',
        nombre_couchages: '',
        budget: '',
        message: ''
      };
      this.flexibleSelected = null;
      this.needSelected = [];
      this.lodgeTypeSelected = [];
      this.formErrors = {};
      this.selectedStartDate = null;
      this.selectedEndDate = null;
    },

    async submit() {
      await this.handleContactSubmit();
    },
    back() {
      window.location.href = '/';
    },
    async fetchHomeLoadings() {
      const responseAccommodation = await fetcher.get(
          "/home_lodgings", {
            params: { collection: 'evenement-eco-responsable' }
          }
        );
      this.accommodations = responseAccommodation.data;
    },
  },
}
</script>

<style lang="scss">
.pe-root .vs__dropdown-toggle {
  padding: 10px 16px;
  border-radius: 8px;
}
</style>
<style lang="scss" scope='app/assets/stylesheets/components/contact-form'>
.home-button {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 8rem;
  margin-bottom: 8rem;
}

/*#my-form{
  input {
    color: #FFFFFF;
  }
}*/
#my-form input::placeholder {
  color: #000000 !important;
  font-family: Raleway !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}

#my-form textarea::placeholder {
  color: #000000 !important;
  font-family: Raleway !important;
  font-weight: 400 !important;
  font-size: 14px !important;
}


#my-form textarea::placeholder {
  color: #000000 !important;
}

.multiselect__placeholder {
  font-family: Raleway !important;
  font-weight: 400 !important;
  font-size: 13px !important;
  color: #000000 !important;
}

.select-item {
  color: #4e6a86;
}

.v-select {
  font-family: Raleway;
  font-weight: 400;
  font-size: 13px;
  color: #4e6a86;
}

.v-select::placeholder {
  font-family: Raleway !important;
  font-weight: 400 !important;
  font-size: 13px !important;
  color: #000000 !important;
}


#my-form {
  #my-form-button {
    width: 15vw;
    display: inline;
    background-color: #3B6152;
  }

  #projet {
    height: 10vw;
  }
}

#footer-made-trip {
  background-image: url("../../images/made-trip/voyage-sur-mesure-footer.png");
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 25vw;
}

.container-index-trip {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .banner-lodge-search {
    z-index: 3;
  }
}

#banner-made-trip {
  width: 100%;
  height: 512px;
  background-image: url("https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/location-mais-vacances.gif");
  background-position: center;
  background-size: cover;
  display: flex;
  align-items: flex-end;
  position: relative;

  .banner-show-container {
    width: 100%;
    height: 512px;
    position: absolute;
    z-index: 2;

    .catch-hub-show {
      color: white;
      margin-top: 4rem;
    }
  }

  .pe-banner-title-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    color: white;
    z-index: 2;
  }

  .pe-banner-title-p {
    color: white;
    margin-bottom: 10px;
  }

  .pe-banner-subtitle-p {
    color: white;
  }

  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .btn-banner {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-left: 0;
    cursor: pointer;
    z-index: 10;
    margin-bottom: 4rem;
  }

  .btn-banner-phone {
    display: none;
    justify-content: center;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {

  /*.select-item {
   margin-top: 3.5rem;
  }*/
  #my-form {
    #my-form-button {
      width: 90%;
    }

    #projet {
      height: 20vw;
    }
  }
  .container-index-trip {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 12vh;
    overflow: hidden;
    overflow-x: hidden;
  }
  #banner-made-trip {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: relative;

    .btn-banner-phone {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-left: 0;
      margin-bottom: 3rem;
      z-index: 10;
      width: unset;
      white-space: nowrap;
    }

    .btn-banner {
      display: none;
    }

    .banner-show-container {
      width: 100%;
      height: 700px;
      display: flex;
      align-items: flex-end;

      .catch-hub-show {
        margin-left: 1rem;

        p {
          font-size: 26px;
        }
      }
    }
  }
}

.padding-desktop {
  padding-left: 13rem;
}


//DatePicker style
.made-trip-duration {
  height: 100%;

  .vhd__datepicker__input:first-child {
    background: white !important;
    border-bottom: 1px solid #ced4da !important;
    width: 48.5% !important;
    color: #000000 !important;
  }

  .vhd__datepicker__input {
    color: #000000 !important;
    text-align: left !important;
    border: 1px solid #ced4da !important;
    font-family: Raleway !important;
    font-weight: 400 !important;
    font-size: 13px !important;
    width: 48.5% !important;
  }

  .vhd__datepicker__dummy-wrapper {
    border-top: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    border-bottom: 0 !important;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    height: 70% !important;
  }
  @media only screen and (max-device-width: 480px) {
  .vhd__datepicker__dummy-wrapper {
  border-top: 0 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-bottom:none !important;
  cursor: pointer;
  display: flex;
  flex-wrap: nowrap !important;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}
}s

  .vd-picker__input input {
    border-bottom: 1px solid black !important;
    border-top: 0 !important;
    border-left: 0 !important;
    border-right: 0 !important;
    text-align: left !important;
    font-family: $Raleway;
    font-weight: 400;
    font-size: 15px;
    color: #4e6a86;

    &::placeholder {
      color: #000000 !important;
    }
  }

  .vd-picker__table-day--selected .vd-picker__table-day__text {
    color: black;
  }

  span.vd-picker__table-day__effect {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 36px;
    height: 36px;
    border-radius: 0 !important;
    border: 1px solid;
  }
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  .made-trip-duration {
    .vhd__datepicker__input:first-child {
      width: 100% !important;
      margin-bottom: 1rem !important;
    }

    .vhd__datepicker__input {
      width: 100% !important;
    }

    .vhd__datepicker__dummy-wrapper {
      margin-bottom: 5rem !important;
    }
  }
}

//Multi select style
.multiselect__option {
  display: block;
  padding: 25px !important;
  min-height: 40px;
  line-height: 16px;
  text-decoration: none;
  text-transform: none;
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  //font-style: italic !important;
  font-size: 13px !important;
  font-family: $Merriweather !important;
  font-weight: 400 !important;
  color: #000000;
}

.multiselect__option::before {
  content: "" !important;
  position: absolute !important;
  left: 10px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  width: 10px !important;
  height: 10px !important;
  background-color: white !important;
  border: 1px solid #3B6152 !important; /* Add a border to the rectangle */
  box-sizing: border-box; /* Ensure that the border doesn't affect the dimensions of the rectangle */
}

.multiselect__option--selected {
  background: white !important;
  color: #4e6a86 !important;
  font-weight: 400 !important;
}

.multiselect__option--selected:after {
  content: "" !important;
  color: #4e6a86 !important;
}

.multiselect__option--selected::before {
  content: "" !important; /* Empty content to create the icon */
  position: absolute !important; /* Absolute positioning relative to the parent element */
  left: 10px !important; /* Position the icon 10px from the left */
  top: 50% !important; /* Vertically center the icon */
  transform: translateY(-50%) !important; /* Adjust vertical alignment */
  width: 10px !important; /* Set the width of the icon */
  height: 10px !important; /* Set the height of the icon */
  background-color: #3B6152 !important; /* Set the background color of the icon */
}

.multiselect__option--highlight {
  background: white !important;
  outline: none;
  color: #000000 !important;
}

.multiselect__option--highlight:after {
  content: "" !important;
  background: white !important;
  color: #4e6a86 !important;
}

.multiselect__option--selected.multiselect__option--highlight {
  background: white !important;
  color: #4e6a86 !important;
}

.multiselect__option--selected.multiselect__option--highlight:after {
  background: white !important;
  content: "" !important;
  color: #4e6a86 !important;
}

.multiselect__tag {
  background: #3B6152;
}

.multiselect__select:before {
  border-color: #3B6152 transparent transparent !important;
  border-width: 10px 7px 0 !important;
  margin-left: 10px !important;
}

//Change the arrows
.vs__clear svg {
  display: none !important;
}

.vs__open-indicator path {
  fill: #3B6152 !important;
  stroke: none !important;
}
#trip-description {
  padding-left: 13%;
  padding-right: 13%;

  @media screen and (max-width: 480px) {
    padding-left: 5%;
    padding-right: 5%;
  }
}
#desire-p {
  display: flex;
  justify-content: center;
  text-align: center;
}

/* Custom Event Section Styles */
.custom-event-section {
  background-color: #f9f9f9;
}

.custom-event-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 4px;
}

.custom-event-video {
  width: 100%;
  height: 400px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
  margin: 0 auto;
}

.custom-event-title {
  color: #000;
  margin-bottom: 1.5rem;

  @media screen and (max-width: 768px) {
    text-align: center;
  }
}

.custom-event-text {
  color: #000;
  margin-bottom: 2rem;
}

/* ─────────────────────────────────────────────────────────────────────
   PRIVATE EVENT FORM STYLES (matching TravelAdvisorPage)
───────────────────────────────────────────────────────────────────── */
.pe-root {
  display: contents;
}

.pe-page {
  background: #ffffff;
  overflow-x: hidden;
}

.pe-contact {
  background: #ffffff;
  padding: clamp(48px, 8vw, 96px) clamp(20px, 8vw, 120px);
  text-align: center;
}

.pe-contact__title {
  color: #0e0000;
  margin: 0 0 14px;
}

.pe-contact__text {
  color: #555;
  margin: 0 auto 40px;
  line-height: 1.7;
  max-width: 760px;
}

/* Form wrapper card */
.pe-contact__form-wrap {
  background: #ffffff;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 15px;
  padding: clamp(28px, 4vw, 52px) clamp(24px, 5vw, 64px);
  max-width: 900px;
  margin: 0 auto;
  text-align: left;
}

.pe-contact__form-title {
  text-align: center;
  color: #0e0000;
  margin: 0 0 20px;
}

.pe-contact__form-divider {
  border: none;
  border-top: 1px solid #D1CCCC;
  margin: 0 0 32px;
}

/* Form rows */
.pe-form-row-1 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}
.pe-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.pe-form-row--full {
  grid-template-columns: 1fr;
}

.pe-form-group--sex {
  flex: 0 0 auto;
}

/* Individual field group */
.pe-form-group {
  display: flex;
  flex-direction: column;
}

.pe-form-label {
  color: #1a1a1a;
  font-size: 13px;
  letter-spacing: 0.5px;
}

/* Inputs & textarea */
.pe-form-input {
  border: 1px solid #d0d0d0;
  border-radius: 8px;
  padding: 12px 16px;
  font-family: 'Raleway', sans-serif;
  font-size: 0.95rem;
  color: #333;
  background: #ffffff;
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
  width: 100%;
  box-sizing: border-box;
}

.pe-form-input:focus {
  outline: none;
  border-color: #2C5E4B;
  box-shadow: 0 0 0 3px rgba(44, 94, 75, 0.1);
}

.pe-form-input::placeholder {
  color: rgba(0, 0, 0, 0.35);
}

.pe-form-textarea {
  resize: vertical;
  min-height: 120px;
}

.pe-form-select {
  width: 100%;
}

.pe-form-multiselect {
  width: 100%;
}

/* Feedback messages */
.pe-form-feedback {
  padding: 10px 14px;
  border-radius: 6px;
  margin-bottom: 16px;
  text-align: center;
}

.pe-form-feedback--error {
  color: #D56A70;
}

.pe-form-feedback--success {
  color: #2C5E4B;
}

/* Field-level error messages */
.pe-form-error {
  display: block;
  color: #D56A70;
  font-size: 12px;
  margin-top: 4px;
  font-family: 'Raleway', sans-serif;
  font-weight: 400;
}

/* Submit button row */
.pe-form-actions {
  display: flex;
  justify-content: center;
  margin-top: 28px;
}

.pe-form-submit {
  padding: 14px 48px;
  letter-spacing: 1.5px;
  min-width: 260px;
}

.pe-form-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Date picker styling */
.made-trip-duration {
  margin: 0;
}

.made-trip-duration .vhd__datepicker__input:first-child {
  background: white !important;
  border-bottom: 1px solid #ced4da !important;
  width: 48.5% !important;
  color: #000000 !important;
}

.made-trip-duration .vhd__datepicker__input {
  color: #000000 !important;
  text-align: left !important;
  border: 1px solid #ced4da !important;
  font-family: Raleway !important;
  font-weight: 400 !important;
  font-size: 13px !important;
  width: 48.5% !important;
}

/* ─────────────────────────────────────────────────────────────────────
   RESPONSIVE — TABLET  (≤ 900px)
───────────────────────────────────────────────────────────────────── */
@media (max-width: 900px) {
  .pe-form-row {
    grid-template-columns: 1fr 1fr;
  }

  .pe-form-row--full {
    grid-template-columns: 1fr;
  }
}

/* ─────────────────────────────────────────────────────────────────────
   RESPONSIVE — MOBILE  (≤ 560px)
───────────────────────────────────────────────────────────────────── */
@media (max-width: 560px) {
  .pe-contact {
    padding: 40px 20px;
  }

  .pe-contact__form-wrap {
    padding: 24px 16px;
  }

  .pe-form-row {
    grid-template-columns: 1fr;
  }

  .pe-form-row--full {
    grid-template-columns: 1fr;
  }

  .pe-form-submit {
    width: 100%;
    min-width: unset;
  }

  .made-trip-duration .vhd__datepicker__input:first-child {
    width: 100% !important;
    margin-bottom: 1rem !important;
  }

  .made-trip-duration .vhd__datepicker__input {
    width: 100% !important;
  }
}

/* ─────────────────────────────────────────────────────────────────────
   BOTTOM STICKY BAR
───────────────────────────────────────────────────────────────────── */
.pe-sticky-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: #3B6152;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px clamp(20px, 5vw, 80px);
  gap: 20px;
}

.pe-sticky-bar__text {
  color: #ffffff;
  margin: 0;
  letter-spacing: 0.5px;
  line-height: 1.4;
}

.pe-sticky-bar__btn {
  flex-shrink: 0;
  display: inline-block;
  color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 15px;
  padding: 10px 28px;
  text-decoration: none;
  letter-spacing: 1px;
  white-space: nowrap;
  transition: background 0.2s ease, color 0.2s ease;
  background: #3B6152;
  cursor: pointer;
}

.pe-sticky-bar__btn:hover {
  background: #ffffff;
  color: #3B6152;
}

@media (max-width: 560px) {
  .pe-sticky-bar {
    flex-direction: column;
    align-items: flex-start;
    padding: 16px 20px;
    gap: 12px;
  }

  .pe-sticky-bar__btn {
    align-self: stretch;
    text-align: center;
  }
}

.icon-grid {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 3rem;
  padding: 2rem 1rem;
}

.icon-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 230px;
  text-align: center;
}

.icon-card img {
  width: 50px;
  margin-bottom: 0.5rem;
}

.icon-card p {
  font-size: 0.85rem;
  font-weight: bold;
  text-transform: uppercase;
  line-height: 1.4;
  margin: 0;
}
.icon-difference {
    h4 {
      font-family: 'Merriweather', serif;
    }
    h1 {
      font-family: 'Merriweather', serif;
    }
  }
.icon-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 768px) {
  .icon-grid {
    display: flex;
    flex-wrap: nowrap;
    gap: 2rem;
    padding: 1rem;
    min-width: max-content;
  }

  .icon-card {
    flex: 0 0 auto;
    width: 160px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 0.5rem;
  }

  .icon-card img {
    max-width: 100%;
    height: auto;
    margin-bottom: 0.5rem;
  }
}
@media (max-width: 485px) {
	.mobile-title{
		font: normal normal normal 18px/40px Merriweather;
	}
	.mobile-sub{
		font: normal normal normal 32px/40px Merriweather;
	}
}

.top-container {
  h4 {
    font-family: 'Merriweather', serif;
  }
  h1 {
    font-family: 'Merriweather', serif;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
